import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) {
      return;
    }
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const next = sessionStorage.getItem("qfq_next") || "/mon-espace";
    sessionStorage.removeItem("qfq_next");
    api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        setUser(data);
        navigate(next, { replace: true, state: { user: data } });
      })
      .catch(() => {
        setUser(false);
        navigate("/connexion", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return <div className="py-32 text-center text-slate-500" data-testid="auth-callback">Connexion en cours…</div>;
}
